var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-12"},[_c('base-input',{staticClass:"input-group-alternative mb-3",attrs:{"placeholder":_vm.placeholder,"addon-right-icon":_vm.icon},model:{value:(_vm.cp),callback:function ($$v) {_vm.cp=$$v},expression:"cp"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }